import React from 'react';
import { processSteps } from '../data/mock';
import { useTheme } from '../context/ThemeContext';

const ProcessSection = () => {
  const { isDark } = useTheme();

  return (
    <section id="process" className={`py-16 sm:py-24 lg:py-32 ${isDark ? 'bg-[#0A0F0D]' : 'bg-[#FAFAFA]'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Section header */}
        <div className="text-center mb-10 sm:mb-16">
          <p className={`font-medium text-xs sm:text-sm uppercase tracking-[0.2em] mb-3 sm:mb-4 ${
            isDark ? 'text-green-500' : 'text-green-600'
          }`}>
            How It Works
          </p>
          <h2 className="font-display font-bold leading-tight" style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}>
            <span className={isDark ? 'text-white' : 'text-gray-900'}>Our </span>
            <span className="gradient-text">Process</span>
          </h2>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connecting line */}
          <div className={`hidden lg:block absolute top-16 left-0 right-0 h-0.5 ${
            isDark 
              ? 'bg-gradient-to-r from-green-900/50 via-green-700/30 to-amber-900/30' 
              : 'bg-gradient-to-r from-green-200 via-green-300 to-amber-200'
          }`} style={{ marginLeft: '12.5%', marginRight: '12.5%' }} />
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {processSteps.map((item, index) => (
              <div key={item.step} className="relative">
                <div className={`premium-card rounded-xl sm:rounded-2xl p-5 sm:p-6 lg:p-8 h-full border ${
                  isDark 
                    ? 'bg-[#111916] border-green-900/20' 
                    : 'bg-white border-gray-100'
                }`}>
                  {/* Step number */}
                  <div className="relative z-10 mb-4 sm:mb-6">
                    <div className={`w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-xl sm:rounded-2xl flex items-center justify-center font-display font-bold text-base sm:text-lg lg:text-xl ${
                      index === processSteps.length - 1 
                        ? 'bg-gradient-to-br from-[#FF8C00] to-[#FFD700] text-white shadow-lg shadow-amber-500/20' 
                        : 'bg-gradient-to-br from-[#006633] to-[#00873D] text-white shadow-lg shadow-green-500/20'
                    }`}>
                      {item.step}
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className={`font-display font-semibold text-base sm:text-lg mb-2 sm:mb-3 ${
                    isDark ? 'text-white' : 'text-gray-900'
                  }`}>
                    {item.title}
                  </h3>

                  {/* Description */}
                  <p className={`text-xs sm:text-sm leading-relaxed ${
                    isDark ? 'text-gray-400' : 'text-gray-600'
                  }`}>
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
